import React, { useEffect, useState, useRef } from "react";
import { Edit, Plus, Trash2, X, Check, Save } from "react-feather";
import { toast } from "react-toastify";
import { Button, UncontrolledTooltip } from "reactstrap";
import { createQuestion, updateComponent, deleteQuestion, updateQuestion, createOption, updateOption, deleteOption } from "../../../services/labServices";
import PopupDelete from "../deletePopUp";
import {
  QuizTitle,
  QuizIndice,
  QuestionTitle,
  QuestionIndice,
  OptionIndice,
  OptionTitle,
  OptionValue,
  Text,
  QuestionTypeList,
  QuestionTypeOption,
  QuizTitleInput,
  QuestionTitleInput,
  RadioInput,
} from "./styles";
import { BlurSpinner } from "../../BlurSpinner";
import { handleErrors } from "../../../services/handleErrors";

export default function QuizComponent({ handleDelete, componentInfo, setNewComponent, setReloadData, unitInfo, setComponentForm }) {
  const inputRef = useRef(null);
  const [isLoadingQuestions, setIsLoadingQuestions] = useState(false);
  const [preguntas, setPreguntas] = useState([]);
  const [isHovered, setIsHovered] = useState(null);
  const [typeList, setTypeList] = useState(false);
  const [deleteComponentPopUp, setDeleteComponentPopUp] = useState(false);
  const [title, setTitle] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [edited, setEdited] = useState("");
  const [quizId, setQuizId] = useState("");

  useEffect(() => {
    // Enfocar el input cuando el componente se monte
    if (isEditing) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  useEffect(() => {
    setIsLoadingQuestions(true);
    if (unitInfo && componentInfo && componentInfo.labQuiz) {
      const currentComponent = unitInfo && unitInfo.components && unitInfo.components.find((component) => component.id === componentInfo.id);
      setPreguntas(currentComponent && currentComponent.labQuiz && currentComponent.labQuiz.labQuizQuestion);
      setQuizId(componentInfo.labQuiz.id);
      setTitle(componentInfo.title);
    }
    setIsLoadingQuestions(false);
  }, [componentInfo, unitInfo]);

  const handleAddQuestion = async (type) => {
    const data = {
      quiz_id: quizId,
      type_quiz: type,
      question_text: "pregunta",
    };
    try {
      const { result } = await createQuestion(data);

      if (type === "TORF") {
        try {
          await createOption({
            question_id: result.id,
            is_correct: true,
            option_text: "verdadero",
          });

          try {
            await createOption({
              question_id: result.id,
              is_correct: false,
              option_text: "falso",
            });
          } catch (error) {
            handleErrors(error, toast.error);
          }
        } catch (error) {
          handleErrors(error, toast.error);
        }
      }
      if (type === "SIMPLE") {
        try {
          await createOption({
            question_id: result.id,
            is_correct: true,
            option_text: "Opción1",
          });

          try {
            await createOption({
              question_id: result.id,
              is_correct: false,
              option_text: "Opción2",
            });

            try {
              await createOption({
                question_id: result.id,
                is_correct: false,
                option_text: "Opción3",
              });
            } catch (error) {
              handleErrors(error, toast.error);
            }
          } catch (error) {
            handleErrors(error, toast.error);
          }
        } catch (error) {
          handleErrors(error, toast.error);
        }
      }
      if (type === "MULTI") {
        try {
          await createOption({
            question_id: result.id,
            is_correct: true,
            option_text: "Opción1",
          });

          try {
            await createOption({
              question_id: result.id,
              is_correct: true,
              option_text: "Opción2",
            });

            try {
              await createOption({
                question_id: result.id,
                is_correct: false,
                option_text: "Opción3",
              });
            } catch (error) {
              handleErrors(error, toast.error);
            }
          } catch (error) {
            handleErrors(error, toast.error);
          }
        } catch (error) {
          handleErrors(error, toast.error);
        }
      }
      setTypeList(false);
      setPreguntas([...preguntas, result]);
      setReloadData(true);
    } catch (error) {
      handleErrors(error, toast.error);
    }
  };

  const handleDeleteQuestion = async (id) => {
    if (preguntas.length === 1) {
      toast.error("Debe tener al menos una pregunta");
    } else {
      try {
        const { message } = await deleteQuestion(id);
        toast.success(message);
        setPreguntas(preguntas.filter((question) => question.id !== id));
        setReloadData(true);
      } catch (error) {
        handleErrors(error, toast.error);
      }
    }
  };

  const handleAddOption = async (data) => {
    if (data.labQuizOption && data.labQuizOption.length > 4) {
      toast.error("No puedes agregar mas de 5 opciones");
    } else {
      try {
        const response = await createOption({
          question_id: data.id,
          is_correct: false,
          option_text: `Opción`,
        });
        toast.success(response.message);
        setReloadData(true);
      } catch (error) {
        handleErrors(error, toast.error);
      }
    }
  };

  const handleInputChange = (event) => {
    setEdited(event.target.value);
  };

  const handleKeyPressEdit = async (event, id, type) => {
    if (event.key === "Enter") {
      if (edited === "") return;

      if (type === "title") {
        try {
          const { result } = await updateComponent(id, { title: edited });
          setNewComponent(result);
          setTitle(edited);
        } catch (error) {
          handleErrors(error, toast.error);
        }
      }

      if (type === "question") {
        try {
          const { result, message } = await updateQuestion(id, { question_text: edited });
          toast.success(message);
          setNewComponent(result);
        } catch (error) {
          handleErrors(error, toast.error);
        }
      }

      if (type === "option") {
        try {
          const { result, message } = await updateOption(id, { option_text: edited });
          toast.success(message);
          setNewComponent(result);
        } catch (error) {
          handleErrors(error, toast.error);
        }
      }
      // Limpiar el campo de entrada después de agregar
      setEdited("");
      setIsEditing(null);
    }
  };

  const handleEdit = async (id, type) => {
    if (edited === "") {
      toast.error("No puedes dejar el campo vacío");
      inputRef.current.focus();
      return;
    }

    if (type === "title") {
      try {
        const { result } = await updateComponent(id, { title: edited });
        setNewComponent(result);
        setTitle(edited);
      } catch (error) {
        handleErrors(error, toast.error);
      }
    }

    if (type === "question") {
      try {
        const { result, message } = await updateQuestion(id, { question_text: edited });
        toast.success(message);
        setNewComponent(result);
      } catch (error) {
        handleErrors(error, toast.error);
      }
    }

    if (type === "option") {
      try {
        const { result, message } = await updateOption(id, { option_text: edited });
        toast.success(message);
        setNewComponent(result);
      } catch (error) {
        handleErrors(error, toast.error);
      }
    }

    // Limpiar el campo de entrada después de agregar
    setEdited("");
    setIsEditing(null);
  };

  const handleGuardarQuiz = () => {
    if (preguntas && preguntas.length > 0) {
      toast.success("Se guardaron los cambios");
      setComponentForm(null);
    } else {
      toast.error("No hay preguntas para guardar");
    }
  };

  const handleEditOptionValue = async (event, option, pregunta) => {
    const correctas = pregunta.labQuizOption.filter((o) => o.is_c);
    const { value } = event.target;
    if (pregunta.type_quiz === "SIMPLE" || pregunta.type_quiz === "TORF") {
      pregunta.labQuizOption.map(async (opcion) => {
        await updateOption(opcion.id, opcion.id === JSON.parse(value) ? { is_correct: true } : { is_correct: false });
      });
    }

    if (pregunta.type_quiz === "MULTI") {
      if (correctas.length < 3 && option.is_c === true) {
        toast.error("En las preguntas de tipo multiple tiene que seleccionar 2 opciones correctas");
      } else {
        await updateOption(option.id, { is_correct: !option.is_c });
      }
    }
    setReloadData(true);
  };

  const handleDeleteOption = async (id) => {
    try {
      const { message } = await deleteOption(id);
      toast.success(message);
      setReloadData(true);
    } catch (error) {
      handleErrors(error, toast.error);
    }
  };

  return (
    <>
      <BlurSpinner isLoading={isLoadingQuestions}>
        {deleteComponentPopUp && (
          <PopupDelete
            isOpen={deleteComponentPopUp}
            toggle={() => setDeleteComponentPopUp(!deleteComponentPopUp)}
            elementToDelete={componentInfo}
            type="component"
            handleDelete={handleDelete}
          />
        )}
        <div className="d-flex flex-column">
          <div className="d-flex">
            <QuizIndice>{componentInfo ? `${componentInfo.sort_order}` : ""}</QuizIndice>
            <QuizTitle
              //  onDoubleClick={() => setIsEditing(true)}
              onMouseEnter={() => setIsHovered("title")}
              onMouseLeave={() => setIsHovered(null)}
            >
              {isEditing === "title" ? (
                <QuizTitleInput
                  type="text"
                  value={edited}
                  onChange={handleInputChange}
                  onKeyDown={(event) => handleKeyPressEdit(event, componentInfo.id, "title")}
                  ref={inputRef}
                />
              ) : (
                // "Test" como titulo por defecto para quiz
                <Text>{title || "Tests"}</Text>
              )}
              <div>
                {isHovered === "title" && (
                  <>
                    {/* se puede editar el Titulo del Quiz */}
                    {/* {isEditing === "title" ? (
                      <X size="14" className="mr-2" style={{ cursor: "pointer" }} onClick={() => setIsEditing(null)} />
                    ) : (
                      <Edit
                        size="14"
                        className="mr-2"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setIsEditing("title");
                          setEdited(title);
                        }}
                      />
                    )} */}
                    <UncontrolledTooltip target="btnDeleteQuiz">Eliminar componente</UncontrolledTooltip>
                    <Trash2 id="btnDeleteQuiz" size="14" className="mr-2" style={{ cursor: "pointer" }} onClick={() => setDeleteComponentPopUp(true)} />
                  </>
                )}

                <UncontrolledTooltip target="btnAddQuestion">Agregar pregunta</UncontrolledTooltip>
                <Plus id="btnAddQuestion" size="14" style={{ cursor: "pointer" }} onClick={() => setTypeList(!typeList)} />
              </div>
            </QuizTitle>
            {typeList && (
              <QuestionTypeList>
                <QuestionTypeOption onClick={() => handleAddQuestion("TORF")}>Verdadero o falso</QuestionTypeOption>
                <QuestionTypeOption onClick={() => handleAddQuestion("MULTI")}>Seleccion multiple</QuestionTypeOption>
                <QuestionTypeOption onClick={() => handleAddQuestion("SIMPLE")}>Eleccion única</QuestionTypeOption>
              </QuestionTypeList>
            )}
          </div>
          {preguntas &&
            preguntas.length > 0 &&
            preguntas
              .sort((a, b) => a.id - b.id)
              .map((pregunta, index) => (
                <div className="mb-3 d-flex flex-column" key={pregunta.id}>
                  <div
                    className="d-flex"
                    style={{ width: "100%", alignSelf: "end" }}
                    onMouseEnter={() => setIsHovered(pregunta.question_text + pregunta.id)}
                    onMouseLeave={() => setIsHovered(null)}
                  >
                    <div style={{ width: "5%", display: "flex", alignItems: "center" }}>
                      {isHovered === pregunta.question_text + pregunta.id ? (
                        <>
                          <UncontrolledTooltip target={`btnDelete${pregunta.id}`}>Eliminar pregunta</UncontrolledTooltip>
                          <Trash2
                            onClick={() => handleDeleteQuestion(pregunta.id)}
                            id={`btnDelete${pregunta.id}`}
                            size="14"
                            style={{ position: "absolute", left: "2%", cursor: "pointer" }}
                          />
                        </>
                      ) : null}
                    </div>
                    <QuestionIndice>{index + 1}</QuestionIndice>
                    <QuestionTitle>
                      {isEditing === pregunta.question_text + pregunta.id ? (
                        <QuestionTitleInput
                          type="text"
                          value={edited}
                          onChange={handleInputChange}
                          onKeyDown={(event) => handleKeyPressEdit(event, pregunta.id, "question")}
                          ref={inputRef}
                          maxLength={200}
                        />
                      ) : (
                        <Text>{pregunta.question_text}</Text>
                      )}
                      <div className="d-flex">
                        {isHovered === pregunta.question_text + pregunta.id && (
                          <>
                            {isEditing === pregunta.question_text + pregunta.id ? (
                              <>
                                <Save size="14" className="mr-2" style={{ cursor: "pointer" }} onClick={() => handleEdit(pregunta.id, "question")} />
                                <X size="14" className="mr-2" style={{ cursor: "pointer" }} onClick={() => setIsEditing(null)} />
                              </>
                            ) : (
                              <>
                                <UncontrolledTooltip target={`btnEdit${pregunta.id}`}>Editar pregunta</UncontrolledTooltip>
                                <Edit
                                  size="14"
                                  id={`btnEdit${pregunta.id}`}
                                  className="mr-2"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    setIsEditing(pregunta.question_text + pregunta.id);
                                    setEdited(pregunta.question_text);
                                  }}
                                />
                              </>
                            )}
                          </>
                        )}
                        {pregunta && pregunta.type_quiz !== "TORF" && (
                          <>
                            <UncontrolledTooltip target={`btnAddOption${pregunta.id}`}>Agregar opción</UncontrolledTooltip>
                            <Plus id={`btnAddOption${pregunta.id}`} size="14" style={{ cursor: "pointer" }} onClick={() => handleAddOption(pregunta)} />
                          </>
                        )}
                      </div>
                    </QuestionTitle>
                  </div>

                  {pregunta.labQuizOption &&
                    pregunta.labQuizOption.length > 0 &&
                    pregunta.labQuizOption
                      .sort((a, b) => a.id - b.id)
                      .map((opcion, optionIndex) => (
                        <div
                          key={opcion.id}
                          className="d-flex mt-2"
                          style={{ width: "100%", alignSelf: "end" }}
                          onMouseEnter={() => {
                            setIsHovered(opcion.id + opcion.opti);
                          }}
                          onMouseLeave={() => setIsHovered(null)}
                        >
                          <div style={{ width: "10%", display: "flex", alignItems: "center" }}>
                            {(pregunta.type_quiz === "SIMPLE" || pregunta.type_quiz === "MULTI") && pregunta.labQuizOption.length > 3 ? (
                              <>
                                {isHovered === opcion.id + opcion.opti && pregunta.type_quiz !== "TORF" ? (
                                  <>
                                    <UncontrolledTooltip placement="top" target={`delete${opcion.id}`}>
                                      Eliminar opción
                                    </UncontrolledTooltip>
                                    <Trash2
                                      onClick={() => handleDeleteOption(opcion.id)}
                                      id={`delete${opcion.id}`}
                                      size="14"
                                      style={{ position: "absolute", left: "6%", cursor: "pointer", margin: "auto" }}
                                    />
                                  </>
                                ) : null}
                              </>
                            ) : null}
                          </div>
                          <OptionIndice>{optionIndex + 1}</OptionIndice>
                          <OptionTitle>
                            {isEditing === opcion.id + opcion.opti ? (
                              <QuestionTitleInput
                                type="text"
                                value={edited}
                                onChange={handleInputChange}
                                onKeyDown={(event) => handleKeyPressEdit(event, opcion.id, "option")}
                                ref={inputRef}
                                maxLength={100}
                              />
                            ) : (
                              <Text>{opcion.opti}</Text>
                            )}
                            {pregunta && pregunta.type_quiz !== "TORF" && (
                              <>
                                {isHovered === opcion.id + opcion.opti && (
                                  <>
                                    {isEditing === opcion.id + opcion.opti ? (
                                      <div className="d-flex align-items-center">
                                        <Save size="14" className="mr-2" style={{ cursor: "pointer" }} onClick={() => handleEdit(opcion.id, "option")} />
                                        <X size="14" className="mr-2" style={{ cursor: "pointer" }} onClick={() => setIsEditing(null)} />
                                      </div>
                                    ) : (
                                      <>
                                        <UncontrolledTooltip placement="top" target={`edit${opcion.id}`}>
                                          Editar opción
                                        </UncontrolledTooltip>
                                        <Edit
                                          id={`edit${opcion.id}`}
                                          size="14"
                                          className="mr-2"
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            setIsEditing(opcion.id + opcion.opti);
                                            setEdited(opcion.opti);
                                          }}
                                        />
                                      </>
                                    )}
                                  </>
                                )}
                              </>
                            )}
                          </OptionTitle>

                          <OptionValue htmlFor={opcion.id}>
                            <Text className="my-0 mx-2" style={opcion.is_c ? { color: "green" } : { color: "black" }}>
                              {opcion.is_c ? "Correcta" : "Incorrecta"}
                            </Text>

                            <RadioInput
                              type="radio"
                              id={opcion.id}
                              name={opcion.id}
                              value={opcion.id}
                              // checked={opcion.is_c}
                              onClick={(event) => handleEditOptionValue(event, opcion, pregunta)}
                            />

                            {opcion.is_c ? <Check color="green" size="14" /> : <X size="14" />}
                          </OptionValue>
                        </div>
                      ))}
                </div>
              ))}
        </div>
        <div className="d-flex justify-content-end mb-2">
          {/* <button className="btn mr-2" style={{ fontSize: "12px" }} type="button" onClick={() => setComponentForm(null)}>
          Cancelar
        </button> */}
          <Button size="sm" className="btn btn-success" type="button" onClick={handleGuardarQuiz}>
            Guardar
          </Button>
        </div>
      </BlurSpinner>
    </>
  );
}
